import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/**
 * 부서의 선택 여부 — 병원별로 기억한다.
 *
 * 서버가 주는 부서 목록과 별개로, 이 브라우저에서 켜고 끈 상태만 남긴다.
 */
export type StoredDepartment = {
    _id: string
    isSelected: boolean
    sortNum?: number
}

export type V2DepartmentState = {
    hospitals: Record<string, StoredDepartment[] | undefined>
}

const state: V2DepartmentState = {
    hospitals: {},
}

const mutations = {
    /** 처음 보는 부서는 새로 넣는다 — 그래야 토글이 persist 된다 */
    MU_V2Department_Update: (
        state: V2DepartmentState,
        param: { hospitalID: string; departments: StoredDepartment[] },
    ): void => {
        const hospitalID = param.hospitalID
        const departments = param.departments
        const origins = state.hospitals[hospitalID] ?? []
        for (let i = 0; i < departments.length; i++) {
            const department = departments[i]
            const origin = origins.find((c) => c._id == department._id)
            if (origin == undefined) {
                origins.push({
                    _id: department._id,
                    isSelected: department.isSelected,
                    sortNum: department.sortNum,
                })
                continue
            }
            origins[origins.indexOf(origin)].isSelected = department.isSelected
        }
        state.hospitals[hospitalID] = origins
    },
}

const V2Department: Module<V2DepartmentState, StoreState> = { state, mutations }

export default V2Department
